export enum RecruiterPlanTypes {
    FETCH_RECRUITER_PLAN_SUCCESS = "FETCH_RECRUITER_PLAN_SUCCESS",
    FETCH_RECRUITER_PLAN_REQUEST = "FETCH_RECRUITER_PLAN_REQUEST",
    FETCH_RECRUITER_PLAN_FAILURE = "FETCH_RECRUITER_PLAN_FAILURE",
}